module.exports = __webpack_public_path__ + "static/media/fedpa-minus.5ef9c243.svg";